import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import WhyFMASection from "./components/WhyFMASection";
import QuickLinksSection from "./components/QuickLinksSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main>
        <HeroSection />
        <StatsSection />
        <WhyFMASection />
        <QuickLinksSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
